import { HttpClient, HttpErrorResponse, HttpEventType, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog, MatStepper } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/@core/services/app.service';
import { JobService } from 'src/@core/services/job/job.service';
import { NotificationService } from 'src/@core/services/notification.service';
import { API_AUTH, API_DOWNLOAD_CALLING_TEMPLATE, API_DOWNLOAD_WO_FULFILMENT, PROJECT_API_KEY, REFRESH_GOOGLE_TOKEN } from 'src/@core/services/util/api.endpoints';
import { TestCallAgentComponent } from 'src/app/modules/agents/create-agent/test-call-agent/test-call-agent.component';
import { EnterpriseAdminService } from 'src/app/modules/enterprise-admin/enterprise-admin.service';
import { environment } from 'src/environments/environment';
import { gapi } from 'gapi-script';
import { ChangeDetectorRef } from '@angular/core';
import { ThemeService } from 'src/@core/services/theme.service';

interface UserToken {
  userId: string;
  email: string;
  googleRefreshToken: string;
}

@Component({
  selector: 'hour4u-admin-create-edit-project',
  templateUrl: './create-edit-project.component.html',
  styleUrls: ['./create-edit-project.component.scss']
})
export class CreateEditProjectComponent implements OnInit {
  @ViewChild('stepper', { static: true }) stepper: MatStepper;

  projectFormGroup: FormGroup;
  scriptFormGroup: FormGroup;
  agentThirdForm: FormGroup;
  profile = this.appService.getCurrentAccount();
  isLoading: boolean = false;
  diameter = 40;
  loaderColor: string;
  mode = 'indeterminate';
  agentsList = [
    // { id: '64b7e2f7d4f8a2e6c9e8f123', name: 'Lead qualifications', badge: 'Sales', minutes: 5 },
    // { id: '64b7e2f7d4f8a2e6c9e8f124', name: 'Support Agent', badge: 'Support', minutes: 10 },
    //{ id: 'f9d74964-8660-4f37-a923-c460c03f0b5c', name: 'Recruitment Agent', badge: 'Marketing', minutes: 15 }
  ];
  progress: number = 0;
  excelFileKey: string | null = null;
  selectedFile: File | null = null;
  progressText: string;
  numberOfChampsAdded: any;
  selectedJob: any = null;
  selectedAction: any = null;
  selectedAgent: any = null;
  showStepper: boolean = false;
  callActions: any[] = [
    // {
    //   id: 1,
    //   value: 'Send email'
    // },
    {
      id: 2,
      value: 'Schedule Meeting'
    },
    // {
    //   id: 3,
    //   value: 'Transfer call'
    // },
    // {
    //   id: 4,
    //   value: 'Send SMS'
    // },
    // {
    //   id: 5,
    //   value: 'Take message and send email'
    // },
    {
      id: 6,
      value: 'Update Status'
    },
  ];
  appearanceList: any[] = [
    {
      id: 1,
      value: 'red',
      label: 'Red'
    },
    {
      id: 2,
      value: 'yellow',
      label: 'Yellow'
    },
    {
      id: 3,
      value: 'blue',
      label: 'Blue'
    },
    {
      id: 4,
      value: 'pink',
      label: 'Pink'
    },
  ];
  times = this.generateTimeSlots();
  timeDifferences: { [key: string]: string } = {};
  timeFrom: any;
  selectedProject: any = null;
  CLIENT_ID: string = environment.googleClientId;
  calendarIntegrated: boolean = false;
  showModal: boolean = false;
  existingAccounts: UserToken[] = [];
  googleScope: string = environment.googleScope;

  constructor(
    private _formBuilder: FormBuilder,
    private appService: AppService,
    private router: Router,
    public enterpriseAdminService: EnterpriseAdminService,
    private http: HttpClient,
    private notify: NotificationService,
    private route: ActivatedRoute,
    private jobService: JobService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    public themeService: ThemeService
  ) { }

  ngOnInit() {
    this.getAllAgents();
    this.initClientGoogle();
    this.projectFormGroup = this._formBuilder.group({
      id: [''],
      projectName: ['', [Validators.required, this.noWhitespaceValidator()]],
      description: ['', [Validators.required, this.noWhitespaceValidator()]],
      userPrompt: this._formBuilder.group({}),
      // agentId: ['', [Validators.required, this.noWhitespaceValidator()]],
      // agentName: ['', [Validators.required, this.noWhitespaceValidator()]]
    })

    this.scriptFormGroup = this._formBuilder.group({
      finalPrompt: [''],
    });

    this.agentThirdForm = this._formBuilder.group({
      outcomes: this._formBuilder.array([this.getOutComesArray()]),
    })

    this.route.params.subscribe(data => {
      console.log(data)
      if (data.id) {
        this.getProjectDetailsById(data.id);
      }
      this.selectedAction = data.action;
    })
  }

  initClientGoogle() {
    gapi.load('client:auth2', () => {
      gapi.auth2
        .init({
          client_id: this.CLIENT_ID,
          cookiepolicy: 'single_host_origin',
          scope: this.googleScope,
          access_type: 'offline',
          // refre
        })
        .then(() => {
          console.log('Google API client initialized');
        })
        .catch((error) => {
          console.error('Error initializing Google API client:', error);
        });
    });
  };

  getOutComesArray() {
    let f = this._formBuilder.group({
      outcome_name: ['', [Validators.required]],
      outcome_appearance: [''],
      outcome_description: [''],
      do_not_consider_for_analysis: [false],
      conditions: this._formBuilder.array([this.getConditionsArray()]),
      callActions: this._formBuilder.array([this.getActionsArray()]),
    });
    return f;
  }

  getConditionsArray() {
    let f = this._formBuilder.group({
      condition: [''],
    });
    return f;
  }

  getActionsArray() {
    let f = this._formBuilder.group({
      call_action: ['', [Validators.required]],
      // email_subject: [''],
      // email_content: [''],
      // when_to_trigger: [''],
      // add_link_to_calendar: [''],
      // days: this._formBuilder.array(this.getDaysArray()), // Days as FormArray
      // slots: this._formBuilder.array([]), // Slots as FormArray  
      // appointment_time: [''],
      // allow_booking_on_same_day_as_call: [''],
      // receive_booking_appointment_notifications_via_email: [''],
      // phone_number: [''],
      // sms_content: [''],
      // emails_list: ['']
    });
    return f;
  }

  // Generate array for days
  getDaysArray() {
    return [
      this.createDayControl('Monday'),
      this.createDayControl('Tuesday'),
      this.createDayControl('Wednesday'),
      this.createDayControl('Thursday'),
      this.createDayControl('Friday'),
      this.createDayControl('Saturday'),
      this.createDayControl('Sunday'),
    ];
  }

  // Create a single day control
  createDayControl(dayName: string) {
    return this._formBuilder.group({
      day: [dayName],
      isSelected: [false],
      startTime: ['08:00 AM'],
      endTime: ['06:00 PM'],
    });
  }

  noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isWhitespace = (control.value || '').trim().length === 0;
      return isWhitespace ? { whitespace: true } : null;
    };
  }


  generateTimeSlots(selectedStartTime?: string, selectedEndTime?: string): {
    timeDifference: string; display: string, value: string
  }[] {
    const times: {
      timeDifference: string; display: string, value: string
    }[] = [];

    for (let h = 0; h < 24; h++) {
      for (let m = 0; m < 60; m += 15) {
        const hour12 = ('0' + (h % 12 || 12)).slice(-2); // Convert 0 to 12 for 12-hour format
        const hour24 = ('0' + h).slice(-2); // 24-hour format
        const minute = ('0' + m).slice(-2);
        const period = h < 12 ? 'AM' : 'PM';

        const displayFormat = `${hour12}:${minute} ${period}`;
        const valueFormat = `${hour24}:${minute}`;

        times.push({
          display: displayFormat, value: valueFormat,
          timeDifference: ''
        });
      }
    }
    times.forEach(time => {
      // Calculate time difference for each time option
      // ... calculate time difference based on your logic
      time.timeDifference = '';// assign the calculated time difference
    });
    return times;
  }

  calculateTimeDifference(start: string, end: string): string {
    if (!start || !end) {
      return '';
    }

    const startTime = new Date(`2000-01-01T${start}`);
    const endTime = new Date(`2000-01-01T${end}`);
    let difference = (endTime.getTime() - startTime.getTime()) / 1000;

    // Adjust for negative durations
    if (difference < 0) {
      difference += 24 * 60 * 60; // Adding a day in seconds
    }

    const hours = Math.floor(difference / 3600);
    const minutes = Math.floor((difference % 3600) / 60);

    return `(${hours}.${(minutes < 10 ? '0' : '') + minutes} hours)`;
  }

  getProjectDetailsById(projectId: string, nextScreen?: boolean) {
    console.log('Fetching project details...');
    this.isLoading = true;

    this.jobService.getProjectById(this.profile.entity.id, projectId).subscribe(
      (response) => {
        this.isLoading = false;
        this.selectedProject = response;
        console.log('✅ Project details retrieved successfully:', response);

        if (response) {
          this.projectFormGroup.controls['id'].setValue(response.project_id);
          this.projectFormGroup.controls['projectName'].setValue(response.project_name);
          this.projectFormGroup.controls['description'].setValue(response.project_description);

          // ✅ Ensure selectedAgent exists
          this.selectedAgent = {
            agent_id: response.agent_id,
            agent_name: response.agent_name,
            variable_inputs: Array.isArray(response.variable_inputs) ? response.variable_inputs : []
          };

          console.log("✅ Selected Agent:", this.selectedAgent);
          console.log("✅ Received user_prompt:", response.user_prompt);

          // ✅ Use user_prompt fields from the project instead of creating new inputs
          let userPromptGroup: { [key: string]: FormControl } = {};
          const userPromptData = response.user_prompt || {}; // Get saved user_prompt

          Object.keys(userPromptData).forEach((key) => {
            console.log(`✅ Adding form control for key: ${key} with value: ${userPromptData[key]}`);
            userPromptGroup[key] = new FormControl(userPromptData[key]);
          });

          // ✅ Set userPrompt in the form
          this.projectFormGroup.setControl('userPrompt', new FormGroup(userPromptGroup));

          console.log("✅ Updated userPrompt FormGroup:", this.projectFormGroup.get('userPrompt').value);

          this.projectFormGroup.updateValueAndValidity();

          this.scriptFormGroup.controls['finalPrompt'].setValue(response.final_prompt);
          this.scriptFormGroup.controls['finalPrompt'].updateValueAndValidity();

          if (nextScreen) {
            this.stepper.selectedIndex = this.stepper.selectedIndex + 1;
          }
          this.setDefaultOutcomes();
        }
      },
      (error) => {
        this.isLoading = false;
        console.error('❌ Failed to fetch project details:', error);
      }
    );
  }

  getAllAgents() {
    this.isLoading = true;
    this.enterpriseAdminService.getAllAgentsByEntityId(this.profile.entity.id, 1000, 1).subscribe(
      (data) => {
        this.isLoading = false;
        this.agentsList = data.items;
        console.log(this.agentsList)
      }, (err => {
        this.isLoading = false;
      }))
  }

  onAgentSelectionChange(agentData: any) {
    // const selectedAgentId = event.value;
    // console.log('Selected agent ID:', selectedAgentId);

    this.projectFormGroup.controls['agentName'].setValue(agentData.agent_name);
    this.projectFormGroup.controls['agentName'].updateValueAndValidity();
  }

  disable() {
    let isDisabled = true;
    if (this.stepper.selectedIndex == 0) {
      if (this.projectFormGroup.valid) {
        isDisabled = false;
      }
    }
    if (this.stepper.selectedIndex == 1) {
      if (this.scriptFormGroup.valid) {
        isDisabled = false;
      }
    }
    if (this.stepper.selectedIndex == 2) {
      if (this.agentThirdForm.valid) {
        isDisabled = false;
      }
    }
    return isDisabled;
  }

  onNext() {
    // this.stepper.selectedIndex = this.stepper.selectedIndex + 1;
    // return;
    if (this.stepper.selectedIndex == 0) {
      if (!this.projectFormGroup.valid) {
        this.projectFormGroup.markAllAsTouched();
        return;
      } else {
        this.saveProject();
      }
    }

    if (this.stepper.selectedIndex == 1) {
      if (!this.scriptFormGroup.valid) {
        this.scriptFormGroup.markAllAsTouched();
        return;
      } else {
        this.saveFinalPrompt();
      }
    }

    if (this.stepper.selectedIndex == 2) {
      if (!this.agentThirdForm.valid) {
        this.agentThirdForm.markAllAsTouched();
        return;
      } else {
        this.saveOutcomes();
      }
    }
  }

  saveProject() {
    this.isLoading = true;
    let obj = {
      "entityId": this.profile.entity.id,
      "agentId": this.selectedAgent.agent_id,
      "agentName": this.selectedAgent.agent_name,
      "userId": this.profile.user.id,
      "userName": this.profile.user.userMeta.name,
      "projectName": this.projectFormGroup.controls['projectName'].value,
      "projectDescription": this.projectFormGroup.controls['description'].value,
      "userPrompt": this.projectFormGroup.controls['userPrompt'].value
    }

    if (this.selectedAction == 'edit') {
      obj["projectId"] = this.projectFormGroup.controls['id'].value;
      this.jobService.updateProject(obj).subscribe(
        (data) => {
          this.notify.showMessage("Project updated successfully!", 2000);
          this.getProjectDetailsById(obj["projectId"], true);
          // this.router.navigate(['/job'], { relativeTo: this.route });
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.notify.showMessage("Error while creating project!", 2000);
        }
      );
    } else {
      this.jobService.createProject(obj).subscribe(
        (data) => {
          this.isLoading = false;
          this.notify.showMessage("Project created successfully!", 2000);
          this.projectFormGroup.controls['id'].setValue(data.project_id);
          this.projectFormGroup.controls['id'].updateValueAndValidity();
          this.getProjectDetailsById(data.project_id, true);
          // this.router.navigate(['/job'], { relativeTo: this.route });
          // if ((this.profile.entity.entityType === 'ENTERPRISE')) {
          // this.openSuccessModal(data, 'Created');
          // }
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.notify.showMessage("Error while creating project!", 2000);
        }
      );
    }
  }

  saveFinalPrompt() {
    let obj = {
      "entityId": this.profile.entity.id,
      "userId": this.profile.user.id,
      "userName": this.profile.user.userMeta.name,
      "projectId": this.projectFormGroup.controls['id'].value,
      "finalPrompt": this.scriptFormGroup.controls['finalPrompt'].value
    }

    this.jobService.updateProject(obj).subscribe(
      (data) => {
        this.isLoading = false;
        this.notify.showMessage("Final prompt updated successfully!", 2000);
        // this.stepper.selectedIndex = this.stepper.selectedIndex + 1;
        this.getProjectDetailsById(this.projectFormGroup.controls['id'].value, true);
        // this.setDefaultOutcomes();
        // this.router.navigate(['/job'], { relativeTo: this.route });
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.notify.showMessage("Error while creating project!", 2000);
      }
    );
  }

  setDefaultOutcomes() {
    const outcomes = this.agentThirdForm.get('outcomes') as FormArray;
    outcomes.clear(); // Clear existing outcomes to avoid duplicates

    if (this.selectedProject && this.selectedProject.expected_outcomes.length) {
      console.log("Populating outcomes from selectedProject:", this.selectedProject.expected_outcomes);
      this.pushOutcomes(this.selectedProject.expected_outcomes);
    } else {
      console.warn("No outcomes found in selectedProject to populate.");
    }

    console.log("Final state of agentThirdForm outcomes:", outcomes.value);
  }

  // Method to push outcomes into the FormArray
  pushOutcomes(outcomesData: any[]) {
    const outcomes = this.agentThirdForm.get('outcomes') as FormArray;

    outcomesData.forEach((outcome) => {
      outcomes.push(
        this._formBuilder.group({
          outcome_name: [outcome.outcome_name || outcome.name || '', [Validators.required]],
          outcome_appearance: [outcome.outcome_appearance || ''],
          outcome_description: [outcome.outcome_description || outcome.description || '', [Validators.required]],
          do_not_consider_for_analysis: [typeof outcome.do_not_consider_for_analysis === 'boolean' ? outcome.do_not_consider_for_analysis : false],
          conditions: this._formBuilder.array(
            (outcome.conditions || []).map((condition: any) =>
              this._formBuilder.group({
                condition: [condition.condition || ''],
              })
            ) || [] // Handle missing conditions
          ),
          callActions: this._formBuilder.array(
            (outcome.callActions || []).map((action: any) =>
              this._formBuilder.group({
                call_action: [action.call_action || '', [Validators.required]],
              })
            ) || [] // Handle missing callActions
          ),
        })
      );
    });
  }

  saveOutcomes() {
    let obj = {
      entityId: this.profile.entity.id,
      userId: this.profile.user.id,
      userName: this.profile.user.userMeta.name,
      projectId: this.projectFormGroup.controls['id'].value,
      expectedOutcomes: this.agentThirdForm.value.outcomes
    };

    this.jobService.updateProject(obj).subscribe(
      (data: any) => {
        this.isLoading = false;
        this.notify.showMessage("Outcomes updated successfully!", 2000);

        // Clear the existing outcomes and push new ones from the response
        const outcomesFormArray = this.agentThirdForm.get('outcomes') as FormArray;
        outcomesFormArray.clear();

        if (data.expected_outcomes && data.expected_outcomes.length) {
          this.pushOutcomes(data.expected_outcomes);
        }

        // Optionally navigate to another screen if needed
        this.router.navigate(['/job'], { relativeTo: this.route });
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.notify.showMessage("Error while updating outcomes!", 2000);
      }
    );
  }

  cancel() {
    this.router.navigate(['/job']);
  }


  handleFileUploaded(event: { key: string, file: File }) {
    console.log('Received S3 file key:', event.key);
    this.excelFileKey = event.key;
    this.selectedFile = event.file;
    console.log('File received in CreateWorkOrder component:', event.file);
  }

  handleFileDeleted() {
    this.excelFileKey = null;
    this.selectedFile = null;
  }

  // Method to create bulk work order
  createBulkWorkOrder(): void {
    if (!this.selectedFile) {
      console.error('No file selected!');
      return;
    }
    this.isLoading = true;

    this.uploadFile().then(() => {
      // this.dialogRef.close(true);
      this.cancel();
    }).catch(error => {
      console.error('Error during data update:', error);
    });
  }

  uploadFile(): Promise<void> {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append('file', this.selectedFile, this.selectedFile.name);

      const apiUrl = `${environment.callingService}upload?entity_id=${this.profile.entity.id}`;
      // const apiUrl = `${environment.projectAPI}uploadProjectExcel?entity_id=${this.profile.entity.id}`;

      const headers = new HttpHeaders({
        'x-api-key': 'LiEw44aP9W74NhiuuXq3f8MUpvJYpRoF3VukyHHQ',
      });

      // Construct a new HTTP request
      const request = new HttpRequest('POST', apiUrl, formData, {
        headers,
        reportProgress: true,
        responseType: 'json'
      });

      this.http.request(request).subscribe(
        (event: any) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              if (event.total) {
                this.progress = Math.round((100 * event.loaded) / event.total);
                console.log(`Uploading... ${this.progress}%`);
              }
              break;

            case HttpEventType.Response:
              console.log('Upload successful!', event.body);
              this.numberOfChampsAdded = event.body.numberOfChampsAdded;
              this.progress = 2;
              setTimeout(() => {
                this.progress = 3;
                this.notify.showMessage(
                  `Records added!`,
                  3000,
                  'assets/tick-circle.svg',
                  `Records added for future call`
                );
                resolve();
              }, 3000);
              break;

            default:
              break;
          }
        },
        error => {
          console.error('Error uploading file:', error);
          reject(error);
        }
      );
    });
  }

  downloadSampleFile(event: Event) {
    event.stopPropagation();
    let environmentType = environment.production ? 'prod/' : 'dev/';
    window.open(environment.image_url + environmentType + API_DOWNLOAD_CALLING_TEMPLATE, '_blank');
  }

  // selectAgent(selectedAgent: any) {
  //   console.log(selectedAgent)
  //   this.selectedAgent = selectedAgent;
  //   this.showStepper = true;
  // }

  selectAgent(selectedAgent: any) {
    console.log("✅ Agent selected:", selectedAgent);
    this.selectedAgent = selectedAgent;

    let userPromptGroup: { [key: string]: FormControl } = {};

    // ✅ Preserve previous userPrompt values if they exist
    let existingUserPrompt = this.projectFormGroup.get('userPrompt').value || {};

    if (this.selectedAgent.variable_inputs) {

      this.selectedAgent.variable_inputs.forEach((key: string) => {
        console.log(`✅ Creating form control for key: ${key}`);
        userPromptGroup[key] = new FormControl(existingUserPrompt[key] || '');
      });
    }
    this.showStepper = true;

    this.projectFormGroup.setControl('userPrompt', new FormGroup(userPromptGroup));
    this.projectFormGroup.updateValueAndValidity();
  }

  nextBtnCTA() {
    let label = "Next";
    if (this.stepper && this.stepper.selectedIndex == 0) {
      label = "Next: Configure script";
    }
    if (this.stepper && this.stepper.selectedIndex == 1) {
      label = "Next: Configure outcomes";
    }
    if (this.stepper && this.stepper.selectedIndex == 2) {
      label = "Save project";
    }
    return label;
  }

  // go To Back Step
  goToBackStep() {
    if (this.stepper.selectedIndex > 0) {
      this.stepper.selectedIndex = this.stepper.selectedIndex - 1;
    } else {
      this.showStepper = false;
    }
  }

  // add more for links
  addMoreLinks() {
    const outcomes = this.agentThirdForm.get('outcomes') as FormArray;
    outcomes.push(this.getOutComesArray());
  }

  // delete Link
  deleteLink(index) {
    const outcomes = this.agentThirdForm.get('outcomes') as FormArray;
    outcomes.removeAt(index);
  }

  // add more condition
  addMoreConditions(outcomeIndex: number) {
    if (outcomeIndex === undefined || outcomeIndex === null) {
      console.error('Outcome index is undefined or null');
      return;
    }

    const outcomes = this.agentThirdForm.get('outcomes') as FormArray;

    if (!outcomes || outcomes.length <= outcomeIndex) {
      console.error(`Outcomes FormArray is not defined or Outcome at index ${outcomeIndex} does not exist`);
      return;
    }

    const selectedOutcome = outcomes.at(outcomeIndex);

    if (!selectedOutcome) {
      console.error(`Outcome at index ${outcomeIndex} does not exist`);
      return;
    }

    const conditions = selectedOutcome.get('conditions') as FormArray;

    if (!conditions) {
      console.error('Conditions FormArray is not defined in the selected outcome');
      return;
    }

    conditions.push(this.getConditionsArray());
  }

  // delete Condition
  deleteCondition(parentIndex, index) {
    const outcomes = this.agentThirdForm.get('outcomes') as FormArray;
    const selectedOutcome = outcomes.at(parentIndex);
    const conditions = selectedOutcome.get('conditions') as FormArray;
    conditions.removeAt(index);
  }

  // add more call action
  addMoreActions(outcomeIndex) {
    if (outcomeIndex === undefined || outcomeIndex === null) {
      console.error('Outcome index is undefined or null');
      return;
    }

    const outcomes = this.agentThirdForm.get('outcomes') as FormArray;

    if (!outcomes || outcomes.length <= outcomeIndex) {
      console.error(`Outcomes FormArray is not defined or Outcome at index ${outcomeIndex} does not exist`);
      return;
    }

    const selectedOutcome = outcomes.at(outcomeIndex);

    if (!selectedOutcome) {
      console.error(`Outcome at index ${outcomeIndex} does not exist`);
      return;
    }

    const callActions = selectedOutcome.get('callActions') as FormArray;

    if (!callActions) {
      console.error('Conditions FormArray is not defined in the selected outcome');
      return;
    }

    callActions.push(this.getActionsArray());
  }

  // delete call action
  deleteCallAction(parentIndex, index) {
    const outcomes = this.agentThirdForm.get('outcomes') as FormArray;
    const selectedOutcome = outcomes.at(parentIndex);
    const callActions = selectedOutcome.get('callActions') as FormArray;
    callActions.removeAt(index);
  }

  addMoreOutcomes() {
    const outcomes = this.agentThirdForm.get('outcomes') as FormArray;
    outcomes.push(this.getOutComesArray());
  }

  deleteOutcomes() {

  }

  linkCalender() {
    const authInstance = gapi.auth2.getAuthInstance();

    authInstance
      .grantOfflineAccess({
        prompt: 'consent', // Ensures the user is prompted for consent
      })
      .then((response) => {
        const authCode = response.code;
        console.log(response);
        console.log('Authorization Code:', authCode);
        return authCode;
      })
      .then((authCode) => {
        const headers = new HttpHeaders({
          'x-api-key': PROJECT_API_KEY,
        });

        const body = {
          code: authCode,
        };

        const request = new HttpRequest(
          'POST',
          REFRESH_GOOGLE_TOKEN,
          body,
          {
            headers,
            reportProgress: true,
            responseType: 'json',
          }
        );

        // Convert HTTP request to a Promise
        return this.http.request(request).toPromise();
      })
      .then((event: any) => {
        if (event.body && event.body.refresh_token) {
          console.log('Refresh token:', event.body.refresh_token);
          this.calendarIntegrated = true;
          this.cdr.detectChanges();
          return event.body.refresh_token; // Pass the token to the next step
        } else {
          throw new Error('Refresh token not received');
        }
      })
      .then((refreshToken) => {
        let obj = {
          entityId: this.profile.entity.id,
          userId: this.profile.user.id,
          userName: this.profile.user.userMeta.name,
          projectId: this.projectFormGroup.controls['id'].value,
          googleCalendarToken: refreshToken,
        };

        return this.jobService.updateProject(obj).toPromise();
      })
      .then((data) => {
        this.isLoading = false;
        this.notify.showMessage(
          'Google calendar integration updated successfully!',
          2000
        );
        this.getProjectDetailsById(
          this.projectFormGroup.controls['id'].value,
          true
        );
      })
      .catch((error) => {
        console.error('Error:', error);
        this.isLoading = false;
        this.notify.showMessage('Error while updating project!', 2000);
      });

  }

  selectAppearance(appearance: any) {

  }

  selectCallAction(callAction: any) {
    console.log(callAction)
  }

  openTestCallAgentPopup() {
    const dialogRef = this.dialog.open(TestCallAgentComponent, {
      width: '900px',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  getFolloupActions(index) {
    const outcomes = this.agentThirdForm.get('outcomes') as FormArray;
    const callActions = outcomes.controls[index].get('callActions') as FormArray;
    let followupActions = [];
    callActions.controls.forEach(ele => {
      if (ele.value.call_action) {
        followupActions.push(ele.value.call_action);
      }
    })
    return followupActions;
  }

  deleteOutcome(index) {
    const outcomes = this.agentThirdForm.get('outcomes') as FormArray;
    outcomes.removeAt(index);
  }

  async handleCalendarLink() {
    try {
      this.isLoading = true;

      // Fetch existing user tokens
      const userTokens = await this.fetchUserTokens(this.profile.user.id);

      if (userTokens.length > 0) {
        this.existingAccounts = userTokens;
        this.showModal = true;
        this.isLoading = false;
      } else {
        // Proceed with original flow
        await this.linkCalenderWithNewAccount();
      }
    } catch (error) {
      console.error('Error handling calendar link:', error);
      this.isLoading = false;
      this.notify.showMessage('Error checking existing accounts!', 2000);
    }
  }

  private async fetchUserTokens(userId: string): Promise<UserToken[]> {
    try {
      const response = await this.http.get<UserToken[]>(API_AUTH + `/v1/user-tokens/${userId}`).toPromise();
      return response || [];
    } catch (error) {
      console.error('Error fetching user tokens:', error);
      throw error;
    }
  }

  private async linkCalenderWithNewAccount() {
    const authInstance = gapi.auth2.getAuthInstance();
    try {
      const response = await authInstance.grantOfflineAccess({
        prompt: 'consent',
      });

      const authCode = response.code;
      console.log('Authorization Code:', authCode);

      const headers = new HttpHeaders({
        'x-api-key': PROJECT_API_KEY,
      });

      const event = await this.http.post<{ refresh_token: string }>(
        REFRESH_GOOGLE_TOKEN,
        { code: authCode },
        {
          headers,
          reportProgress: true
        }
      ).toPromise();

      if (event && event.refresh_token) {
        console.log('Refresh token:', event.refresh_token);
        this.saveRefreshToken(this.profile.user.id, this.profile.user.email, event.refresh_token);
        this.calendarIntegrated = true;
        this.cdr.detectChanges();

        const projectData = {
          entityId: this.profile.entity.id,
          userId: this.profile.user.id,
          userName: this.profile.user.userMeta.name,
          projectId: this.projectFormGroup.controls['id'].value,
          googleCalendarToken: event.refresh_token,
        };

        await this.jobService.updateProject(projectData).toPromise();

        this.isLoading = false;
        this.notify.showMessage('Google calendar integration updated successfully!', 2000);
        this.getProjectDetailsById(this.projectFormGroup.controls['id'].value, true);
      } else {
        throw new Error('Refresh token not received');
      }
    } catch (error) {
      console.error('Error:', error);
      this.isLoading = false;
      this.notify.showMessage('Error while updating project!', 2000);
    }
  }

  async selectExistingAccount(account: UserToken) {
    try {
      this.isLoading = true;
      this.showModal = false;

      const projectData = {
        entityId: this.profile.entity.id,
        userId: this.profile.user.id,
        userName: this.profile.user.userMeta.name,
        projectId: this.projectFormGroup.controls['id'].value,
        googleCalendarToken: account.googleRefreshToken,
      };

      await this.jobService.updateProject(projectData).toPromise();

      this.calendarIntegrated = true;
      this.isLoading = false;
      this.notify.showMessage('Google calendar integration updated successfully!', 2000);
      this.getProjectDetailsById(this.projectFormGroup.controls['id'].value, true);
    } catch (error) {
      console.error('Error updating with existing account:', error);
      this.isLoading = false;
      this.notify.showMessage('Error while updating project!', 2000);
    }
  }

  useNewAccount() {
    this.showModal = false;
    this.linkCalenderWithNewAccount();
  }

  closeModal() {
    this.showModal = false;
    this.isLoading = false;
  }

  saveRefreshToken(userId: string, email: string, refreshToken: string): void {
    const userTokenDto = { userId, email, googleRefreshToken: refreshToken };
    const authToken = localStorage.getItem("jwtToken");

    const headers = new HttpHeaders({
      'Authorization': '${authToken}',
      'Content-Type': 'application/json'
    });

    this.http.post(API_AUTH + '/v1/user-tokens/save', userTokenDto, { headers })
      .subscribe({
        next: () => console.log("Refresh token stored successfully!"),
        error: (err) => console.error("Failed to store refresh token:", err)
      });
  }
}
